import formatDate from '~support-at-home/lib/formatDate';

import { Column } from '~components/table-view';
import { genericCellRender } from '~components/table-view/columnRenderers';
import { renderSyncStatusBadge } from '~support-at-home/components/proda/SahReferenceDataCells';

// Column[] for the "Reference Data" tab's sync-status table.
//
// A plain array rather than a factory: the "Message" and "Actions" columns were removed (TAV-2589)
// because this tab is read-only status reporting, not something a user acts on row by row. With the
// per-row refresh button gone, nothing here closes over the manager's live busy state, so there is
// no longer any reason to rebuild the column set on every render.
export const sahReferenceDataColumns: Column[] = [
  {
    id: 'title',
    header: 'List',
    type: 'text',
  },
  {
    id: 'last_run',
    header: 'Last Updated',
    type: 'text',
    // Branch on the source value, not on formatDate's em-dash return — that em dash is that
    // helper's own empty-value sentinel, and coupling to it would silently show '—' here if it
    // ever changed.
    deriveValue: (row) => (row.last_run ? formatDate(row.last_run) : 'Never'),
  },
  {
    id: 'last_status',
    header: 'Status',
    type: 'text',
    renderReadOnly: genericCellRender(renderSyncStatusBadge),
  },
  {
    id: 'record_count',
    header: 'Records',
    type: 'text',
    deriveValue: (row) =>
      row.record_count === null || row.record_count === undefined ? '—' : String(row.record_count),
  },
];
